import { createContext } from 'react';

export const DrawerContext = createContext<{
  onInnerFormChange?: (isDirty: boolean) => void;
}>({
  onInnerFormChange: undefined
});
